/*=========================================================================================
  File Name: moduleEcommerceState.js
  Description: Ecommerce Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
    syncServer:false,
    shippingCost:undefined,
    forceUp:false,
    hasCoupon:false,
    coupon:undefined,
    total:0,
    discount:0,
    proDiscount:0,
    cartItems: [],
    address:{},
    wishList: []
}
